/** Resultados visibles por "página" en la lista de búsqueda (grid de cards). */
export const SEARCH_LIST_ITEMS_PER_PAGE = 12

export function parseListPageFromQuery(pageQuery) {
  const p = parseInt(pageQuery, 10)
  if (isNaN(p) || p < 1) return 1
  return Math.min(p, 100)
}

export function clampListPage(page, totalResults, itemsPerPage = SEARCH_LIST_ITEMS_PER_PAGE) {
  if (!totalResults || totalResults <= 0) return Math.max(1, page)
  const maxPage = Math.max(1, Math.ceil(totalResults / itemsPerPage))
  return Math.min(Math.max(1, page), maxPage)
}

export function itemsNeededForListPage(listPage, itemsPerPage = SEARCH_LIST_ITEMS_PER_PAGE) {
  return listPage * itemsPerPage
}
